import { ISpacerWidgetData, ISpacerWidgetStyle, SpacerWidgetData } from "@pageBuilder/typings";
import { WidgetRendererBase } from "./widget-renderer-base";

export class SpacerWidgetRenderer extends WidgetRendererBase<ISpacerWidgetData> {

    protected createNewInternal(): HTMLElement {
        const element = this.createWidgetElement("spacerWidget");
        element.classList.add("aspect-ratio-resizable");

        return element;
    }

    protected renderInternal(element: HTMLElement, data: ISpacerWidgetData): HTMLElement {
        this.renderStyles(element, data);

        return element;
    }

    protected renderStyles(element: HTMLElement, data: ISpacerWidgetData): void {
        this.renderBaseStyles(element, data.style);
    }

    private renderBaseStyles(element: HTMLElement, style: ISpacerWidgetStyle | null): void {
        if (!element.classList.contains("aspect-ratio-resizable")) {
            element.classList.add("aspect-ratio-resizable");
        }

        if (style?.heightData?.paddingTop) {
            element.style.paddingTop = `${style.heightData.paddingTop}%`;
        } else {
            element.style.paddingTop = `${SpacerWidgetData.defaultStyle.heightData?.paddingTop}%`; // 4:1
        }

        this.animationRenderer.setAnimationStyles(element, style?.animation);
    }

    protected getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`, `#${element.id} .spacer`];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        // nothing
    }

}
